import request from "utils/request";
import { baseRequestURL } from "api/BaseAPI";

// Get a list of the marketplaces available
export function getMarketplaces() {
  return request(baseRequestURL + "v1/marketplaces", {
    method: "GET"
  }).then((response) => response);
}

// Creates a new marketplace
/* marketplace = {
  "title": str,
  "description": str,
  "public": bool or null (if null, the marketplace is marked as "UNPUBLISHED" and nothing may be purchased from it ever.)
} */
export function createMarketplace(marketplace) {
  return request(baseRequestURL + "v1/marketplaces", {
    method: "POST",
    body: JSON.stringify(marketplace)
  }).then((response) => response);
}

// Get the marketplace details for a specific marketpalce
export function getMarketplace(id) {
  return request(baseRequestURL + "v1/marketplace/" + id, {
    method: "GET"
  }).then((response) => response);
}

// Edits the marketplace
/* marketplace = {
    "flags": Optional[MarketplaceFlags] where MarketplaceFlags IN (UNPUBLISHED, PUBLISHED_INTERNAL, PUBLISHED_EXTERNAL),
    "title": Optional[str],
    "description": Optional[str]
} */
export function editMarketplace(id, marketplace) {
  return request(baseRequestURL + "v1/marketplace/" + id, {
    method: "PATCH",
    body: JSON.stringify(marketplace)
  }).then((response) => response);
}

// Get a list of all offers already purchased from the marketplace
export function getPurchasedOffers(id) {
  return request(baseRequestURL + "v1/marketplace/" + id + "/purchased", {
    method: "GET"
  }).then((response) => response);
}

// Get a list of all offers currently on offer in the marketplace
export function getMarketplaceOffers(id) {
  return request(baseRequestURL + "v1/marketplace/" + id + "/offers", {
    method: "GET"
  }).then((response) => response);
}

// Publishes an item to the marketplace
/* offer = {
  "type": "blueprint",
  "name": str,
  "description": str,
  "blueprint_id": int,
  "status": Optional[MarketplaceStatus] which defaults to DRAFT. Can be DRAFT / PUBLISHED / ARCHIVED
} */
export function publishToMarketplace(id, offer) {
  return request(baseRequestURL + "v1/marketplace/" + id + "/offers", {
    method: "POST",
    body: JSON.stringify(offer)
  }).then((response) => response);
}

// Publishes an item to the marketplace
/* offer = {
  "status": Optional[MarketplaceStatus] which can be DRAFT / PUBLISHED / ARCHIVED,
  "name": Optional[str],
  "description": Optional[str],
  "blueprint_id": Optional[int],
} */
export function editOffer(id, offer) {
  return request(baseRequestURL + "v1/offer/" + id, {
    method: "PATCH",
    body: JSON.stringify(offer)
  }).then((response) => response);
}

// Archives the marketplace listing, removing it from the marketplace
export function deleteOffer(id) {
  return request(baseRequestURL + "v1/offer/" + id, {
    method: "DELETE"
  }).then((response) => response);
}

// Buys the blueprint from the market using the offer_id
// Original author stored in blueprint.wizard.marketplace.created_by
export function buyBlueprint(id) {
  return request(baseRequestURL + "v1/offer/" + id + "/buy", {
    method: "POST"
  }).then((response) => response);
}

// Gets the purchased offer from the purchase_id in blueprint.purchase_id
// Provides marketplace_id and offer_id
export function getPurchasedInfo(id) {
  return request(baseRequestURL + "v1/purchased/" + id, {
    method: "GET"
  }).then((response) => response);
}
